import { render, staticRenderFns } from "./BaseContact.vue?vue&type=template&id=75ff94b3&scoped=true&"
import script from "./BaseContact.vue?vue&type=script&lang=js&"
export * from "./BaseContact.vue?vue&type=script&lang=js&"
import style0 from "./BaseContact.vue?vue&type=style&index=0&id=75ff94b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ff94b3",
  null
  
)

export default component.exports